import React from 'react';

import { DirectorioBlanco, Folder } from '../../../../assets/images/index';

import {
  StyledBoxInside,
  StyledTitleWidget,
  StyledDocumentsList,
  StyledDocumentsItem,
  StyledDocumentsDownload,
  IconDocuments,
  StyledDocumentsName
} from './style';

const RelevantDocumentation = () => (
  <StyledBoxInside>
    <StyledTitleWidget
      title="Documentación relevante"
      icon={DirectorioBlanco}
      small
      type="employeeDirectory"
    />
    <StyledDocumentsList>
      <StyledDocumentsItem>
        <StyledDocumentsDownload to="/cumplimiento-normativo">
          <IconDocuments svg={Folder} />
          <StyledDocumentsName>Cumplimiento normativo</StyledDocumentsName>
        </StyledDocumentsDownload>
      </StyledDocumentsItem>
      <StyledDocumentsItem>
        <StyledDocumentsDownload to="/prevencion-y-ssmm">
          <IconDocuments svg={Folder} />
          <StyledDocumentsName>Prevención y SSMM</StyledDocumentsName>
        </StyledDocumentsDownload>
      </StyledDocumentsItem>
      <StyledDocumentsItem>
        <StyledDocumentsDownload to="/proteccion-de-datos">
          <IconDocuments svg={Folder} />
          <StyledDocumentsName>Protección de datos</StyledDocumentsName>
        </StyledDocumentsDownload>
      </StyledDocumentsItem>
    </StyledDocumentsList>
  </StyledBoxInside>
);

export default RelevantDocumentation;
